import { Period } from '@scope/scope-one-ui/core/SentimentBar/SentimentBar.d';
import { useGet } from 'shared/hooks/useFetch';
import {
  AttentionBuzzBreakdown,
  EsgEventsList,
  EsgPeriodIndustryScore,
  EsgPeriodScore,
  PeerGroupComparisionInfo,
  SectionA,
  TopCompanies,
  E_S_GData,
  ESGHistory,
  EsgTotalData,
  PeerGroupComparisonChartData,
  SentifyCompany,
  SentifyRequests,
  SentifyStatus,
} from '../types/esgSentiment.d';

export const useGeneralInformation = () => ({
  data: ['Entity Review', 'Without entity participation', 'Subscription', 'Unsolicited'],
});

export const useGetHistoryChart = (entityId: string) =>
  useGet<SectionA>(`/sentifi/daily-score/${entityId}?_filter=6months`);

export const useGetEsgEvents = (companyId: string, eventType: 'E' | 'S' | 'G', filter: Period) =>
  useGet<EsgEventsList>(`/sentifi/esg-event/${companyId}/${eventType}?_filter=${filter}`);

export const useGetPeriodScore = (companyId: string, filter: Period) =>
  useGet<EsgPeriodScore>(`/sentifi/period-score/${companyId}?_filter=${filter}`);

export const useGetPeriodIndustryScore = (companyId: string, filter: Period) =>
  useGet<EsgPeriodIndustryScore>(`/sentifi/period-industry-score/${companyId}?_filter=${filter}`);

export const useGetPeerGroupComparison = (companyId: string) =>
  useGet<PeerGroupComparisonChartData>(`/sentifi/peer-group-comparison/${companyId}`);

export const useGetAttentionBuzzBreakdown = (companyId: string, filter: Period) =>
  useGet<AttentionBuzzBreakdown>(
    `/sentifi/period-score-attention-buzz/${companyId}?_filter=${filter}`,
  );

export const useGetCompareCompanyIndustry = (companyId: string) =>
  useGet<PeerGroupComparisionInfo>(`/sentifi/compare-company-industry/${companyId}`);

export const useGetTopCompanies = (companyId: string) =>
  useGet<TopCompanies>(`/sentifi/top-companies-peer-industry/${companyId}`);

export const useGetESGTotalData = (companyId: string, timeRange: string) =>
  useGet<EsgTotalData>(
    `/sentifi/esg-over-time-score/${companyId}?_filter=${timeRange}&order_by=-date`,
  );

export const useGetE_S_GData = (companyId: string, timeRange: string) =>
  useGet<E_S_GData>(
    `/sentifi/e-s-g-over-time-score/${companyId}?_filter=${timeRange}&order_by=-date`,
  );

export const useGetESGHistory = (scoreType: string, companyId: string, timeRange: string) =>
  useGet<ESGHistory>(
    `/sentifi/e-s-g-history/${companyId}/${scoreType}?_filter=${timeRange}&order_by=-date`,
  );

export const useGetCompanyInfo = (companyId: string) =>
  useGet<SentifyCompany>(`/sentifi/company/${companyId}`);

export const useGetSentifyRequests = () =>
  useGet<SentifyRequests>(`/sentifi/organization-company/`);

export const useGetAvailability = (id: string) =>
  useGet<SentifyStatus>(`/sentifi/organization-company/${id}`);
